/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetAccountStatuses$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountStatusesRequest = createAction<PayloadData<void>>('GET_ACCOUNT_STATUSES__GET_ACCOUNT_STATUSES__REQUEST');
export const getAccountStatusesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_ACCOUNT_STATUSES__GET_ACCOUNT_STATUSES__SUCCESS');
export const getAccountStatusesFailure = createAction<PayloadData<Error, void, true>>('GET_ACCOUNT_STATUSES__GET_ACCOUNT_STATUSES__FAILURE');

export const getAccountStatusesActions = [
    getAccountStatusesRequest,
    getAccountStatusesSuccess,
    getAccountStatusesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountStatuses = (config?: GetAccountStatuses$Config) => {
    return {
        CALL_API: {
            types: getAccountStatusesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/account-status`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

